import { render, staticRenderFns } from "./EmployeePpeSizes.vue?vue&type=template&id=1c912bee&scoped=true&"
import script from "./EmployeePpeSizes.vue?vue&type=script&lang=js&"
export * from "./EmployeePpeSizes.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePpeSizes.vue?vue&type=style&index=0&id=1c912bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c912bee",
  null
  
)

export default component.exports